<button class="btn btn-info" style="margin: 15px;">Ajouter un document</button>
<h3>Photos</h3>
<div class="row">
    <ng-container *ngIf="photos.length > 0">
        <ng-container *ngFor="let photo of photos">
                <app-photo  [photo]="photo"></app-photo>
        </ng-container>
    </ng-container>
</div>
<h3>Documents</h3>
<ul>
    <li *ngFor="let doc of documents">
       <app-document [document]="doc"></app-document>
    </li>
</ul>
